import script from "./QuickCalmListPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuickCalmListPage.vue?vue&type=script&lang=ts&setup=true"

import "./QuickCalmListPage.vue?vue&type=style&index=0&id=1824acd7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1824acd7"]])

export default __exports__